/* ============================================================
   Piper Hero family - runtime (assets/piper-hero.js)
   Countdown, promo-code copy, product spotlight switcher, video
   pause, and the slider that wraps the hero blocks.
   No DOMContentLoaded: runs when loaded, re-inits on
   shopify:section:load, follows shopify:block:select.
   ============================================================ */
(function () {
  'use strict';
  var PH = window.PiperHero = window.PiperHero || {};
  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function qa(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- countdown: hidden until its start, counts to its end, then shows the end message ---------- */
  function countdown(el) {
    var end = new Date(el.getAttribute('data-end') || ''), start = new Date(el.getAttribute('data-start') || '');
    var over = el.querySelector('.ph-count-over'), row = el.querySelector('.ph-count-row'), label = el.querySelector('.ph-count-label');
    if (isNaN(end.getTime())) { return; }
    var q = function (k) { return el.querySelector('[data-' + k + ']'); };
    function tick() {
      var now = Date.now();
      if (!isNaN(start.getTime()) && now < start.getTime()) { el.hidden = true; return; }
      el.hidden = false;
      var ms = end.getTime() - now;
      if (ms <= 0) {
        clearInterval(el._t);
        if (row) { row.hidden = true; } if (label) { label.hidden = true; }
        if (over) { over.textContent = el.getAttribute('data-expired') || ''; over.hidden = !over.textContent; }
        if (over && !over.textContent) { el.hidden = true; }
        return;
      }
      var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      if (q('d')) { q('d').textContent = pad(d); } if (q('h')) { q('h').textContent = pad(h); }
      if (q('m')) { q('m').textContent = pad(m); } if (q('s')) { q('s').textContent = pad(sec); }
      el.classList.toggle('is-urgent', d === 0);
    }
    tick(); el._t = setInterval(tick, 1000);
  }

  /* ---------- promo code: the stub copies the code ---------- */
  function promoCode(b) {
    b.addEventListener('click', function () {
      var code = b.getAttribute('data-ph-code') || '', lab = b.querySelector('.ph-code-stub em');
      var done = function () { b.classList.add('is-copied'); if (lab) { lab.textContent = 'Copied'; } setTimeout(function () { b.classList.remove('is-copied'); if (lab) { lab.textContent = 'Copy'; } }, 2200); };
      if (navigator.clipboard) { navigator.clipboard.writeText(code).then(done, done); } else { done(); }
    });
  }

  /* ---------- product spotlight: one product per block, thumbnails switch everything ---------- */
  function productSpotlight(root) {
    var pdata = root.querySelector('[data-ph-products]');
    if (!pdata) { return; }
    var products = []; try { products = JSON.parse(pdata.textContent || '[]'); } catch (e) { products = []; }
    var buy = root.querySelector('[data-ph-buy]');
    function paintBuy() {
      if (!buy) { return; }
      var sel = buy.querySelector('[data-ph-select]'), price = buy.querySelector('[data-ph-price]'), sub = buy.querySelector('[data-ph-sub]'), add = buy.querySelector('[data-ph-add]');
      if (!sel) { return; }
      var o = sel.options[sel.selectedIndex]; if (!o) { return; }
      if (price) { price.textContent = o.getAttribute('data-price') || ''; }
      if (sub) { sub.textContent = o.getAttribute('data-sub') || ''; }
      if (add) {
        add.setAttribute('href', (root.getAttribute('data-ph-cart') || '/cart/add') + '?id=' + o.value + '&quantity=1&return_to=/cart');
        add.classList.toggle('is-out', o.disabled); add.setAttribute('aria-disabled', o.disabled ? 'true' : 'false');
        if (o.disabled) { add.setAttribute('tabindex', '-1'); } else { add.removeAttribute('tabindex'); }
      }
    }
    function showProduct(i, animate) {
      var pr = products[i]; if (!pr) { return; }
      var f = function (k) { return root.querySelector('[data-ph-f="' + k + '"]'); };
      var img = root.querySelector('[data-ph-pimg]');
      var swap = qa(root, '.ph-swap');
      var fill = function () {
        var words = (pr.name || '').split(' ');
        if (f('name')) { f('name').innerHTML = words.length > 1 ? esc(words.slice(0, -1).join(' ')) + ' <em>' + esc(words[words.length - 1]) + '</em>' : esc(pr.name); }
        if (f('notes')) { f('notes').innerHTML = (pr.notes || []).map(esc).join(' <i>·</i> '); f('notes').hidden = !(pr.notes && pr.notes.length) || f('notes').getAttribute('data-ph-off') === '1'; }
        if (f('rating')) { f('rating').innerHTML = '<span class="ph-stars"><i style="width:' + (Number(pr.rating || 0) / 5 * 100) + '%"></i></span><b>' + Number(pr.rating || 0).toFixed(1) + '</b> ' + (pr.count || 0) + ' reviews'; f('rating').hidden = !(pr.count > 0) || f('rating').getAttribute('data-ph-off') === '1'; }
        if (f('sub')) { f('sub').textContent = pr.sub || ''; }
        if (f('quote')) { f('quote').innerHTML = pr.quote ? '&ldquo;' + esc(pr.quote) + '&rdquo;<b>' + esc(pr.by || '') + '</b>' : ''; f('quote').hidden = !pr.quote || f('quote').getAttribute('data-ph-off') === '1'; }
        if (f('link')) { f('link').setAttribute('href', pr.url || '#'); }
        var sel = buy && buy.querySelector('[data-ph-select]');
        if (sel) {
          sel.innerHTML = (pr.formats || []).map(function (x) { return '<option value="' + esc(x[0]) + '" data-price="' + esc(x[2]) + '" data-sub="' + esc(x[1]) + '"' + (x[3] ? '' : ' disabled') + '>' + esc(x[1]) + ' · ' + esc(x[2]) + (x[3] ? '' : ' · Sold out') + '</option>'; }).join('');
          for (var k = 0; k < sel.options.length; k++) { if (!sel.options[k].disabled) { sel.selectedIndex = k; break; } }
          var wrap = sel.closest('.ph-select-wrap'); if (wrap) { wrap.hidden = sel.options.length < 2 || wrap.getAttribute('data-ph-off') === '1'; }
          paintBuy();
        }
        if (img && pr.img) { img.src = pr.img; if (pr.srcset) { img.srcset = pr.srcset; } img.alt = pr.name || ''; }
      };
      qa(root, '[data-ph-tab]').forEach(function (t) { var on = Number(t.getAttribute('data-ph-tab')) === i; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      if (!animate) { fill(); return; }
      swap.forEach(function (el) { el.classList.add('is-swapping'); }); if (img) { img.classList.add('is-swapping'); }
      setTimeout(function () { fill(); swap.forEach(function (el) { el.classList.remove('is-swapping'); }); if (img) { img.classList.remove('is-swapping'); } }, 300);
    }
    if (products.length) {
      var startIdx = 0; qa(root, '[data-ph-tab]').forEach(function (t) { if (t.classList.contains('is-on')) { startIdx = Number(t.getAttribute('data-ph-tab')); } });
      showProduct(startIdx, false);
      qa(root, '[data-ph-tab]').forEach(function (t) { t.addEventListener('click', function () { showProduct(Number(t.getAttribute('data-ph-tab')), true); }); });
      var tabs = root.querySelector('[data-ph-tabs]'); if (tabs && products.length < 2) { tabs.hidden = true; }
    }
    if (buy) { var bsel = buy.querySelector('[data-ph-select]'); if (bsel) { bsel.addEventListener('change', paintBuy); paintBuy(); } }
  }

  /* ---------- photo carousel (Content + Card) ---------- */
  function carousel(c) {
    var imgs = qa(c, '.ph-carousel-frame img'), dots = c.querySelector('[data-ph-dots]'), cap = c.querySelector('[data-ph-cap]');
    var idx = 0, timer = null, every = parseInt(c.getAttribute('data-interval'), 10) || 4500;
    if (imgs.length < 2) { var nav = c.querySelector('.ph-carousel-nav'); if (nav) { nav.hidden = true; } if (dots) { dots.hidden = true; } if (cap && imgs[0]) { cap.textContent = imgs[0].getAttribute('data-cap') || ''; } return; }
    imgs.forEach(function (x, n) { if (x.classList.contains('is-on')) { idx = n; } });
    if (dots) { dots.innerHTML = imgs.map(function (x, k) { return '<button type="button" data-k="' + k + '" aria-label="Photo ' + (k + 1) + '"></button>'; }).join(''); }
    function go(k) {
      idx = (k + imgs.length) % imgs.length;
      imgs.forEach(function (x, n) { x.classList.toggle('is-on', n === idx); });
      if (dots) { [].slice.call(dots.children).forEach(function (d, n) { d.classList.toggle('is-on', n === idx); }); }
      if (cap) { cap.textContent = imgs[idx].getAttribute('data-cap') || ''; }
    }
    function arm() { clearInterval(timer); if (!REDUCED) { timer = setInterval(function () { go(idx + 1); }, every); } }
    go(idx); arm();
    c.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) { return; }
      if (b.hasAttribute('data-ph-next')) { go(idx + 1); } else if (b.hasAttribute('data-ph-prev')) { go(idx - 1); } else if (b.hasAttribute('data-k')) { go(Number(b.getAttribute('data-k'))); }
      arm();
    });
    c.addEventListener('mouseenter', function () { clearInterval(timer); }); c.addEventListener('mouseleave', arm);
    c._stop = function () { clearInterval(timer); }; c._start = arm;
  }

  /* ---------- photo bubbles (Content + Card): click to expand ---------- */
  function bubbles(cl) {
    var list = qa(cl, '.ph-bubble');
    function open(b) { list.forEach(function (x) { x.classList.toggle('is-open', x === b); }); cl.classList.toggle('has-open', !!b); }
    cl._open = open;
    list.forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (e.target.closest('.ph-bubble-close')) { e.preventDefault(); open(null); b.focus(); return; }
        if (e.target.closest('a')) { return; }
        if (!b.classList.contains('is-open')) { open(b); }
      });
      b.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === b) { e.preventDefault(); open(b); }
        if (e.key === 'Escape') { open(null); b.focus(); }
      });
    });
  }

  /* ---------- video hero ---------- */
  function video(root) {
    var v = root.querySelector('[data-ph-video], .ph-media video'), p = root.querySelector('[data-ph-play]');
    if (!v) { return; }
    v.setAttribute('aria-hidden', 'true'); v.setAttribute('tabindex', '-1');
    root._video = v;
    if (p) { p.addEventListener('click', function () { if (v.paused) { v.play(); root.classList.remove('is-paused'); p.setAttribute('aria-label', 'Pause video'); } else { v.pause(); root.classList.add('is-paused'); p.setAttribute('aria-label', 'Play video'); } }); }
    if (REDUCED) { v.pause(); root.classList.add('is-paused'); if (p) { p.setAttribute('aria-label', 'Play video'); } }
  }

  /* ---------- one hero root ---------- */
  function initHero(root) {
    if (!root || root.hasAttribute('data-ph-init')) { return; }
    root.setAttribute('data-ph-init', '1');
    qa(root, '[data-ph-countdown]').forEach(countdown);
    qa(root, '[data-ph-code]').forEach(promoCode);
    productSpotlight(root);
    qa(root, '[data-ph-carousel]').forEach(carousel);
    qa(root, '[data-ph-bubbles]').forEach(bubbles);
    video(root);
  }

  /* ---------- the slider ---------- */
  var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';
  var ICON_PAUSE = '<svg class="ph-ic-pause" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg><svg class="ph-ic-play" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
  var LIGHT = { 'ph-pal-cream': 1, 'ph-pal-oat': 1, 'ph-pal-marigold': 1 };

  function initSlider(el) {
    if (!el || el.hasAttribute('data-ph-init')) { return; }
    el.setAttribute('data-ph-init', '1');
    var slides = qa(el, ':scope > .ph-slide');
    if (!el.hasAttribute('data-design-mode')) { slides = slides.filter(function (s) { return !s.classList.contains('ph-slide--archived'); }); qa(el, '.ph-slide--archived').forEach(function (s) { s.remove(); }); }
    slides.forEach(function (s) { initHero(s.querySelector('[data-ph]')); });
    var n = slides.length, idx = 0, timer = null, paused = false, hovered = false, hidden = false;
    var auto = el.getAttribute('data-autoplay') === 'true' && !REDUCED;
    var every = Math.max(2000, parseInt(el.getAttribute('data-interval'), 10) || 6000);
    var pagerStyle = el.getAttribute('data-pager') || 'dots', arrows = el.getAttribute('data-arrows') || 'all';
    var pauseHover = el.getAttribute('data-pause-hover') !== 'false';
    el.style.setProperty('--ph-interval', every + 'ms');
    slides.forEach(function (s, i) { s.setAttribute('aria-label', (i + 1) + ' of ' + n); s.setAttribute('data-ph-i', i); });
    if (n < 2) { slides.forEach(function (s) { s.classList.add('is-active'); s.setAttribute('aria-hidden', 'false'); }); el.classList.add('is-one'); return; }
    el.classList.add('is-many');

    /* controls */
    var pager = null, pauseBtn = null;
    if (pagerStyle !== 'none') {
      pager = document.createElement('div'); pager.className = 'ph-pager ph-pager--' + pagerStyle; pager.setAttribute('role', 'tablist'); pager.setAttribute('aria-label', 'Choose a banner');
      pager.innerHTML = slides.map(function (s, i) {
        var lab = s.getAttribute('data-ph-name') || ('Banner ' + (i + 1));
        var inner = pagerStyle === 'numbers' ? pad(i + 1) + '<i></i>' : '<i></i>';
        return '<button type="button" role="tab" data-k="' + i + '" aria-label="' + esc(lab) + '">' + inner + '</button>';
      }).join(pagerStyle === 'numbers' ? '<b>/</b>' : '');
      el.appendChild(pager); el.classList.add('has-pager');
      if (auto) {
        pager.classList.add('is-auto');
        pauseBtn = document.createElement('button'); pauseBtn.type = 'button'; pauseBtn.className = 'ph-pause'; pauseBtn.setAttribute('aria-label', 'Pause banners'); pauseBtn.innerHTML = ICON_PAUSE;
        pager.appendChild(pauseBtn);
        pauseBtn.addEventListener('click', function () { paused = !paused; el.classList.toggle('is-paused', paused); pauseBtn.setAttribute('aria-label', paused ? 'Play banners' : 'Pause banners'); arm(); });
      }
      pager.addEventListener('click', function (e) { var b = e.target.closest('button[data-k]'); if (!b) { return; } go(Number(b.getAttribute('data-k')), true); });
    }
    if (arrows !== 'none') {
      var prev = document.createElement('button'), next = document.createElement('button');
      prev.type = next.type = 'button'; prev.className = 'ph-arrow ph-arrow--prev'; next.className = 'ph-arrow ph-arrow--next';
      prev.setAttribute('aria-label', 'Previous banner'); next.setAttribute('aria-label', 'Next banner');
      prev.innerHTML = ICON_PREV; next.innerHTML = ICON_NEXT;
      el.appendChild(prev); el.appendChild(next);
      if (arrows === 'desktop') { el.classList.add('ph-arrows-desktop'); }
      prev.addEventListener('click', function () { go(idx - 1, true); }); next.addEventListener('click', function () { go(idx + 1, true); });
    }
    var live = document.createElement('div'); live.className = 'ph-sr'; live.setAttribute('aria-live', 'polite'); live.setAttribute('aria-atomic', 'true'); el.appendChild(live);

    function setLight(s) { var root = s.querySelector('[data-ph]'); var light = false; if (root) { for (var k in LIGHT) { if (root.classList.contains(k)) { light = true; } } } el.classList.toggle('is-light', light); }
    function mediaFor(s, on) {
      var root = s.querySelector('[data-ph]'); if (!root) { return; }
      if (root._video) { if (on && !root.classList.contains('is-paused')) { var p = root._video.play(); if (p && p.catch) { p.catch(function () {}); } } else { root._video.pause(); } }
      qa(root, '[data-ph-carousel]').forEach(function (c) { if (on && c._start) { c._start(); } else if (c._stop) { c._stop(); } });
    }
    var ready = false, hTimer = null;
    function go(k, byUser) {
      var nk = (k + n) % n; if (ready && nk === idx && slides[idx].classList.contains('is-active')) { return; }
      var h0 = el.offsetHeight;
      el.classList.toggle('is-back', byUser && ((nk < idx && !(idx === n - 1 && nk === 0)) || (idx === 0 && nk === n - 1)));
      slides.forEach(function (s, i) {
        var on = i === nk, was = i === idx;
        s.classList.toggle('is-active', on); s.classList.toggle('is-leaving', was && !on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in s) { s.inert = !on; }
        mediaFor(s, on);
        if (on) { /* replay the copy entrance */ qa(s, '.ph-copy > *').forEach(function (c) { c.style.animation = 'none'; void c.offsetWidth; c.style.animation = ''; }); }
      });
      idx = nk;
      /* the band animates from the old slide's height to the new one */
      if (ready && !REDUCED && el.classList.contains('ph-trans-none') === false) {
        clearTimeout(hTimer); el.style.transition = 'none'; el.style.height = '';
        var h1 = el.offsetHeight;
        if (h1 !== h0) { el.style.height = h0 + 'px'; void el.offsetWidth; el.style.transition = ''; el.style.height = h1 + 'px'; hTimer = setTimeout(function () { el.style.height = ''; }, 850); }
        else { el.style.transition = ''; }
      }
      if (pager) { qa(pager, 'button[data-k]').forEach(function (b, i) { b.classList.toggle('is-on', i === idx); b.setAttribute('aria-selected', i === idx ? 'true' : 'false'); b.setAttribute('tabindex', i === idx ? '0' : '-1'); }); }
      setLight(slides[idx]);
      if (byUser) { live.textContent = 'Banner ' + (idx + 1) + ' of ' + n; }
      setTimeout(function () { slides.forEach(function (s) { s.classList.remove('is-leaving'); }); }, 900);
      if (byUser) { arm(); }
    }
    function arm() {
      clearInterval(timer);
      var playing = auto && !paused && !hovered && !hidden;
      if (pager) { pager.classList.toggle('is-playing', playing); }
      if (playing) {
        if (pager) { qa(pager, '.is-on i').forEach(function (i) { i.style.animation = 'none'; void i.offsetWidth; i.style.animation = ''; }); }
        timer = setInterval(function () { go(idx + 1, false); }, every);
      }
    }
    if (pauseHover) {
      el.addEventListener('mouseenter', function () { hovered = true; arm(); });
      el.addEventListener('mouseleave', function () { hovered = false; arm(); });
    }
    el.addEventListener('focusin', function () { hovered = true; arm(); });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) { hovered = false; arm(); } });
    document.addEventListener('visibilitychange', function () { hidden = document.hidden; arm(); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (x) { hidden = !x.isIntersecting || document.hidden; arm(); }); }, { threshold: .15 });
      io.observe(el);
    }
    el.addEventListener('keydown', function (e) {
      if (e.target.closest('select, input, textarea')) { return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1, true); }
    });
    /* swipe */
    var x0 = null, y0 = null;
    el.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') { return; } x0 = e.clientX; y0 = e.clientY; }, { passive: true });
    el.addEventListener('pointerup', function (e) {
      if (x0 === null) { return; } var dx = e.clientX - x0, dy = e.clientY - y0; x0 = y0 = null;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) { go(idx + (dx < 0 ? 1 : -1), true); }
    }, { passive: true });
    el.addEventListener('pointercancel', function () { x0 = y0 = null; });

    el._go = go; el._pause = function (on) { paused = on; el.classList.toggle('is-paused', on); arm(); };
    var start = 0; slides.forEach(function (s, i) { if (s.classList.contains('is-active')) { start = i; } });
    go(start, false); ready = true; arm();
    window.addEventListener('resize', function () { if (el.style.height) { el.style.height = ''; } });
  }

  /* ---------- public ---------- */
  PH.init = function (scope) {
    scope = scope || document;
    qa(scope, '[data-ph-slider]').forEach(initSlider);
    if (scope !== document && scope.matches && scope.matches('[data-ph-slider]')) { initSlider(scope); }
    qa(scope, '[data-ph]').forEach(function (r) { if (!r.closest('[data-ph-slider]')) { initHero(r); } });
  };
  PH.init(document);

  /* theme editor */
  document.addEventListener('shopify:section:load', function (e) { PH.init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target && e.target.closest ? e.target.closest('.ph-slide') : null; if (!s) { return; }
    var sl = s.closest('[data-ph-slider]'); if (sl && sl._go) { sl._go(Number(s.getAttribute('data-ph-i')) || 0, true); sl._pause(true); }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var s = e.target && e.target.closest ? e.target.closest('.ph-slide') : null; if (!s) { return; }
    var sl = s.closest('[data-ph-slider]'); if (sl && sl._pause) { sl._pause(false); }
  });
})();
